import { post, postJson } from '@/utils/request';

/******** 首页统计 Start ********/
export const platData = params => {
  return post(`/app/etmt/platData`, params);
};
export const trendByYear = params => {
  return post(`/app/etmt/trendByYear`, params);
};
export const entrustmentStateData = params => {
  return post(`/app/etmt/entrustmentStateData`, params);
};
// 待办事项
export const todoCnt = params => {
  return post(`/app/etmt/todoCnt`, params);
};
// 保养提醒
export const upkeepInfo = params => {
  return post(`/app/etmt/upkeepInfo `, params);
};
/******** 首页统计 End ********/
